import React from 'react'

const CheckedIcon = () => ((
  <span className="mr-2">
    <ion-icon name="checkmark"></ion-icon>
  </span>
))

export default CheckedIcon



// WEBPACK FOOTER //
// ./src/components/CheckedIcon/index.jsx